import { render, staticRenderFns } from "./Toupload.vue?vue&type=template&id=4e48e880&scoped=true&"
import script from "./Toupload.vue?vue&type=script&lang=ts&"
export * from "./Toupload.vue?vue&type=script&lang=ts&"
import style0 from "./Toupload.vue?vue&type=style&index=0&id=4e48e880&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48e880",
  null
  
)

export default component.exports